import { render, staticRenderFns } from "./OtherOfficeFacilityDetail.vue?vue&type=template&id=bfc9eac8&scoped=true&lang=pug"
import script from "./OtherOfficeFacilityDetail.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeFacilityDetail.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeFacilityDetail.vue?vue&type=style&index=0&id=bfc9eac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc9eac8",
  null
  
)

export default component.exports